import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Constant } from 'src/assets/constant';
import { AccountActions } from '../account/ngrx/account-action-types';
import { LogoutService } from '../account/services/logout.service';
import { BehaviorSubjectService } from '../utility-packages/is-logged-in/behaviorSubject.service';
import { VersionHelper } from '../utility-packages/versionHelper/version-helper';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavComponent implements OnInit {

  @Output() closeSideNav = new EventEmitter();

  public version!: string;

  isLogin = false;
  private subscriptions:Subscription = new Subscription();

  constructor(
    public behaviorSubjectService: BehaviorSubjectService,
    private logoutService: LogoutService,
    private store: Store,
    public translate: TranslateService,
    public behaviourSubjectService: BehaviorSubjectService,
    private router: Router,
  ) {
    this.version = Constant.version;
  }

  onToggleClose() {
    this.closeSideNav.emit();
  }

  public onLanguageChangeClicked = (lang:string) => {
    this.translate.use(lang);
  };

  public onLogOut = () => {
    this.onToggleClose();
    this.logoutService.logOut();
    this.store.dispatch(AccountActions.UserInformationUnreachable());
  }

  public onLogin = () => {
    this.router.navigate(['account/login'])
    this.onToggleClose();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.behaviorSubjectService.isUserLoginBS.subscribe(status => this.isLogin = status)
    );
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

}
